import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { FiMail, FiLock, FiEye, FiEyeOff, FiAlertCircle } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { ROLE_HOME_ROUTE } from '../../models/roles';
import './LoginView.css';

export default function LoginView() {
  const { isAuthenticated, user, login, isSubmitting, error, clearError } = useAuth();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  if (isAuthenticated) {
    const redirectTo = location.state?.from?.pathname || ROLE_HOME_ROUTE[user.role] || '/';
    return <Navigate to={redirectTo} replace />;
  }

  function handleFieldChange(setter) {
    return (event) => {
      setter(event.target.value);
      if (error) clearError();
    };
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!email || !password || isSubmitting) return;
    try {
      await login(email, password);
    } catch {
      // El error ya queda expuesto vía `error` del contexto.
    }
  }

  return (
    <div className="login-view">
      <div className="login-view__hero">
        <div className="login-view__brand">
          <span className="login-view__logo">P17</span>
          Pulso17
        </div>
        <h1 className="login-view__title">Bienvenido de nuevo</h1>
        <p className="login-view__subtitle">
          Inicia sesión para capturar, revisar y analizar información en campo.
        </p>
      </div>

      <form className="login-view__form" onSubmit={handleSubmit} noValidate>
        {error && (
          <div className="form-error" role="alert">
            <FiAlertCircle /> {error}
          </div>
        )}

        <div className="field">
          <label htmlFor="email">Correo electrónico</label>
          <div className="field-control">
            <FiMail aria-hidden="true" />
            <input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              inputMode="email"
              placeholder="nombre@pulso17.com"
              value={email}
              onChange={handleFieldChange(setEmail)}
            />
          </div>
        </div>

        <div className="field">
          <label htmlFor="password">Contraseña</label>
          <div className="field-control">
            <FiLock aria-hidden="true" />
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={handleFieldChange(setPassword)}
            />
            <button
              type="button"
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </div>
        </div>

        <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
          {isSubmitting ? 'Ingresando…' : 'Iniciar sesión'}
        </button>

        <p className="login-view__footer">Pulso17 · v0.1.0</p>
      </form>
    </div>
  );
}
